// src/utils/timezonesList.js

export const timezonesList = [
  {
    value: "America/Adak",
    label: "HAST - Hawaii Aleutian Time, UTC-10 with DST",
  },
  {
    value: "Pacific/Honolulu",
    label: "HST - Hawaii Time, UTC-10 no DST",
  },
  {
    value: "Pacific/Marquesas",
    label: "MART - Marquesas Islands Time, UTC-9:30 no DST",
  },
  {
    value: "America/Anchorage",
    label: "AKT - Alaska Time, UTC-9 with DST",
  },
  {
    value: "Pacific/Gambier",
    label: "GAMT - Gambier Islands Time, UTC-9 no DST",
  },
  {
    value: "America/Los_Angeles",
    label: "PT - Pacific Time, UTC-8 with DST",
  },
  {
    value: "Pacific/Pitcairn",
    label: "PST - Pacific Standard Time, UTC-8 no DST",
  },
  {
    value: "America/Denver",
    label: "MT - Mountain Time, UTC-7 with DST",
  },
  {
    value: "America/Phoenix",
    label: "MST - Arizona Mountain Time, UTC-7 no DST",
  },
  {
    value: "America/Chicago",
    label: "CT - Central Time, UTC-6 with DST",
  },
  {
    value: "America/Belize",
    label: "CST - Cape Verde Time 1, UTC-6 no DST",
  },
  {
    value: "America/New_York",
    label: "ET - Eastern Time, UTC-5 with DST",
  },
  {
    value: "America/Jamaica",
    label: "EST - Quintana Roo, Jamaica, Panama, UTC-5 no DST",
  },
  {
    value: "America/Halifax",
    label: "AT - Atlantic Time, UTC-4 with DST",
  },
  {
    value: "America/Puerto_Rico",
    label: "AST - Atlantic Standard Time, UTC-4 no DST",
  },
  {
    value: "America/St_Johns",
    label: "NT - Newfoundland Time, UTC-3:30 with DST",
  },
  {
    value: "America/Scoresbysund",
    label: "EGT/EGST - East Greenland Time, UTC-1 with DST",
  },
  {
    value: "Atlantic/Cape_Verde",
    label: "CVT - Cape Verde Time 2, UTC-1 no DST",
  },
  {
    value: "Europe/London",
    label: "GMT/BST - Coordinated Universal Time, UTC with DST",
  },
  {
    value: "Etc/UTC",
    label: "GMT - Dublin, Edinburgh, Lisbon, London, UTC no DST",
  },
  {
    value: "Europe/Paris",
    label: "CET/CEST - Central European Time, UTC+1 with DST",
  },
  {
    value: "Africa/Algiers",
    label: "CET - Algeria, Tunisia, UTC+1 no DST",
  },
  {
    value: "Europe/Athens",
    label: "EET/EEST - Eastern European Time, UTC+2 with DST",
  },
  {
    value: "Africa/Maputo",
    label: "EET - EET Year Round, UTC+2 no DST",
  },
  {
    value: "Africa/Nairobi",
    label: "EAT - Eastern Africa Time, UTC+3 no DST",
  },
  {
    value: "Asia/Tehran",
    label: "IRST/IRDT - Iran Time, UTC+3:30 with DST",
  },
  {
    value: "Asia/Kabul",
    label: "AFT - Afghanistan Time, UTC+4:30 no DST",
  },
  {
    value: "Asia/Kolkata",
    label: "IST - India Standard Time, UTC+5:30 no DST",
  },
  {
    value: "Asia/Kathmandu",
    label: "NPT - Nepal Time, UTC+5:45 no DST",
  },
  {
    value: "Asia/Yangon",
    label: "MMT - Myanmar Time, UTC+6:30 no DST",
  },
  {
    value: "Australia/Perth",
    label: "AWST - AU Western Time, UTC+8 no DST",
  },
  {
    value: "Australia/Eucla",
    label: "ACWDT - AU Central Western Time, UTC+8:45 no DST",
  },
  {
    value: "Asia/Tokyo",
    label: "JST - Japan Standard Time, UTC+9 no DST",
  },
  {
    value: "Australia/Adelaide",
    label: "ACT - AU Central Time, UTC+9:30 with DST",
  },
  {
    value: "Australia/Darwin",
    label: "ACST - Northern Territory, UTC+9:30 no DST",
  },
  {
    value: "Australia/Sydney",
    label: "AET - AU Eastern Time, UTC+10 with DST",
  },
  {
    value: "Australia/Brisbane",
    label: "AEST - Queensland, UTC+10 no DST",
  },
  {
    value: "Australia/Lord_Howe",
    label: "LHST/LHDT - Lord Howe Time, UTC+10:30 with DST",
  },
  {
    value: "Pacific/Auckland",
    label: "NZST/NZDT - New Zealand Time, UTC+12 with DST",
  },
  {
    value: "Pacific/Tarawa",
    label: "GILT - Gilbert Island Time, UTC+12 no DST",
  },
  {
    value: "Pacific/Chatham",
    label: "CHAST/CHADT - Chatham Islands Time, UTC+12:45 with DST",
  },
];
